import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SupervisorAction, SupervisorSubPhase } from '../../../models/communication/app-enums.model';
import { SupervisorState } from '../../../models/communication/app-state.model';

/**
 * A simple panel with the overlay showing messages to the superuser.
 */
@Component({
    selector: 'app-supervisor-panel',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './supervisor-panel.component.html',
    styleUrl: './supervisor-panel.component.scss'
})
export class SupervisorPanelComponent {
    @Input()
    title = '';

    @Input()
    message = '';

    @Input()
    inverseColors = false;

    @Input()
    showBackButton = true;

    @Input()
    supervisorState?: SupervisorState;

    @Output()
    readonly backClicked = new EventEmitter();

    @Output()
    readonly confirmSupervisorAction = new EventEmitter();

    protected readonly SupervisorSubPhase = SupervisorSubPhase;
    protected readonly SupervisorAction = SupervisorAction;
}
